import apiClient from '../utils/apiClient';

const base = (fid) => `/api/facilities/${fid}/signable-docs`;

const signableDocsService = {
  docTypes: (fid) => apiClient.get(`${base(fid)}/doc-types`),
  fields: (fid, docType) => apiClient.get(`${base(fid)}/templates/${docType}/fields`),
  // PDF preview — returns a blob
  preview: (fid, docType, fieldValues) =>
    apiClient.post(`${base(fid)}/preview`,
      { doc_type: docType, field_values: fieldValues },
      { responseType: 'blob' }),
  create: (fid, docType, fieldValues) =>
    apiClient.post(base(fid), { doc_type: docType, field_values: fieldValues }),
  // Send-any-document path: PDF passes through; Word converts server-side.
  // Content-Type MUST be overridden here: apiClient defaults to
  // application/json, which makes axios serialize the FormData as JSON —
  // the file never reaches the server and FastAPI 422s on the missing
  // field (the 2026-08-13 upload crash). multipart/form-data lets axios
  // set the real boundary itself.
  upload: (fid, file, title) => {
    const form = new FormData();
    form.append('file', file);
    if (title) form.append('title', title);
    return apiClient.post(`${base(fid)}/upload`, form, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
  },
  send: (fid, docId, recipientName, recipientEmail) =>
    apiClient.post(`${base(fid)}/${docId}/send`,
      { recipient_name: recipientName, recipient_email: recipientEmail }),
  // Placed-field flow (owner, 2026-08-14): save the placed boxes + the
  // operator's signature identity, then send to N recipients (each gets
  // their own signing token).
  saveFields: (fid, docId, body) =>
    apiClient.put(`${base(fid)}/${docId}/fields`, body),
  sendMulti: (fid, docId, recipients) =>
    apiClient.post(`${base(fid)}/${docId}/send`, { recipients }),

  // Send history — what was generated/sent, to whom, when.
  list: (fid, params) => apiClient.get(base(fid), { params }),
  get: (fid, docId) => apiClient.get(`${base(fid)}/${docId}`),
  remove: (fid, docId) => apiClient.delete(`${base(fid)}/${docId}`),
  // `signed` fetches the countersigned copy (with its appended audit page).
  pdf: (fid, docId, signed = false) =>
    apiClient.get(`${base(fid)}/${docId}/pdf`, {
      params: signed ? { signed: true } : undefined,
      responseType: 'blob',
    }),

  // Public signing (token only)
  publicMeta: (token) => apiClient.get(`/api/sign-doc/${token}`),
  publicPdf: (token) => apiClient.get(`/api/sign-doc/${token}/pdf`, { responseType: 'blob' }),
  publicSubmit: (token, data) => apiClient.post(`/api/sign-doc/${token}/submit`, data),
};

export default signableDocsService;
